export default "__VITE_ASSET__Cdk$KqcP__"